
export interface StaticLoadState {
    selectedPlanId: string;
    selectedDivision: string;
    weekStartDate: string;
    sourceDay: string;
    turnNumber: string;
}
  
export const initialState: StaticLoadState = {
    selectedPlanId: "",
    selectedDivision: "",
    weekStartDate: "",
    sourceDay: "",
    turnNumber: ""
};
  